/**
 * Shared evidence / status badge.
 *
 * Uses `--status-*` tokens from `@rynora/theme`. Unavailable / unknown /
 * conditional must never visually read as success.
 */

import { forwardRef } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import type { StatusTone } from '@rynora/theme';

export type StatusBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: StatusTone;
  children?: ReactNode;
};

export const StatusBadge = forwardRef<HTMLSpanElement, StatusBadgeProps>(function StatusBadge(props, ref) {
  const { tone = 'neutral', className, children, ...rest } = props;
  const cls = ['rui-status', `rui-status--${tone}`, className].filter(Boolean).join(' ');
  return (
    <span ref={ref} className={cls} data-status={tone} {...rest}>
      {children}
    </span>
  );
});
